var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-member"},[_c('div',{staticClass:"title"},[_vm._v("开通会员，可查看测评报告")]),_c('div',{staticClass:"box",on:{"click":_vm.openMember}},[_vm._v(" 去开通会员 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }